// StateTaxReference2025.js

// Reference data from https://taxfoundation.org/data/all/state/state-income-tax-rates/
export const STATE_TAX_DATA_2025 = {
  'AL': {
    'name': 'Alabama',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.04, 'threshold': 500 },
        { 'rate': 0.05, 'threshold': 3000 },
      ],
      'standardDeduction': 3000,
      'personalExemption': 1500,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.04, 'threshold': 1000 },
        { 'rate': 0.05, 'threshold': 6000 },
      ],
      'standardDeduction': 8500,
      'personalExemption': 3000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Alabama - 2% to 5%',
  },
  'AK': {
    'name': 'Alaska',
    'singleFiler': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'marriedJoint': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'hasIncomeTax': false,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'description': 'Alaska - No state income tax',
  },
  'AZ': {
    'name': 'Arizona',
    'singleFiler': {
      'brackets': [{ 'rate': 0.025, 'threshold': 0 }],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.025, 'threshold': 0 }],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Arizona - 2.5% flat',
  },
  'AR': {
    'name': 'Arkansas',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.039, 'threshold': 4500 },
      ],
      'standardDeduction': 2410,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.039, 'threshold': 4500 },
      ],
      'standardDeduction': 4820,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Arkansas - 2% to 3.9%',
  },
  'CA': {
    'name': 'California',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.01, 'threshold': 0 },
        { 'rate': 0.02, 'threshold': 10756 },
        { 'rate': 0.04, 'threshold': 25499 },
        { 'rate': 0.06, 'threshold': 40245 },
        { 'rate': 0.08, 'threshold': 55866 },
        { 'rate': 0.093, 'threshold': 70606 },
        { 'rate': 0.103, 'threshold': 360659 },
        { 'rate': 0.113, 'threshold': 432787 },
        { 'rate': 0.123, 'threshold': 721314 },
        { 'rate': 0.133, 'threshold': 1000000 },
      ],
      'standardDeduction': 5540,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.01, 'threshold': 0 },
        { 'rate': 0.02, 'threshold': 21512 },
        { 'rate': 0.04, 'threshold': 50998 },
        { 'rate': 0.06, 'threshold': 80490 },
        { 'rate': 0.08, 'threshold': 111732 },
        { 'rate': 0.093, 'threshold': 141732 },
        { 'rate': 0.103, 'threshold': 721318 },
        { 'rate': 0.113, 'threshold': 865574 },
        { 'rate': 0.123, 'threshold': 1000000 },
        { 'rate': 0.133, 'threshold': 1442628 },
      ],
      'standardDeduction': 11080,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'California - 1% to 13.3%',
  },
  'CO': {
    'name': 'Colorado',
    'singleFiler': {
      'brackets': [{ 'rate': 0.044, 'threshold': 0 }],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.044, 'threshold': 0 }],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Colorado - 4.4% flat',
  },
  'CT': {
    'name': 'Connecticut',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.045, 'threshold': 10000 },
        { 'rate': 0.055, 'threshold': 50000 },
        { 'rate': 0.06, 'threshold': 100000 },
        { 'rate': 0.065, 'threshold': 200000 },
        { 'rate': 0.069, 'threshold': 250000 },
        { 'rate': 0.0699, 'threshold': 500000 },
      ],
      'standardDeduction': null,
      'personalExemption': 15000,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.045, 'threshold': 20000 },
        { 'rate': 0.055, 'threshold': 100000 },
        { 'rate': 0.06, 'threshold': 200000 },
        { 'rate': 0.065, 'threshold': 400000 },
        { 'rate': 0.069, 'threshold': 500000 },
        { 'rate': 0.0699, 'threshold': 1000000 },
      ],
      'standardDeduction': null,
      'personalExemption': 24000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Connecticut - 2% to 6.99%',
  },
  'DE': {
    'name': 'Delaware',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.022, 'threshold': 2000 },
        { 'rate': 0.039, 'threshold': 5000 },
        { 'rate': 0.048, 'threshold': 10000 },
        { 'rate': 0.052, 'threshold': 20000 },
        { 'rate': 0.0555, 'threshold': 25000 },
        { 'rate': 0.066, 'threshold': 60000 },
      ],
      'standardDeduction': 3250,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.022, 'threshold': 2000 },
        { 'rate': 0.039, 'threshold': 5000 },
        { 'rate': 0.048, 'threshold': 10000 },
        { 'rate': 0.052, 'threshold': 20000 },
        { 'rate': 0.0555, 'threshold': 25000 },
        { 'rate': 0.066, 'threshold': 60000 },
      ],
      'standardDeduction': 6500,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Delaware - 2.2% to 6.6%',
  },
  'FL': {
    'name': 'Florida',
    'singleFiler': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'marriedJoint': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'hasIncomeTax': false,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'description': 'Florida - No state income tax',
  },
  'GA': {
    'name': 'Georgia',
    'singleFiler': {
      'brackets': [{ 'rate': 0.0539, 'threshold': 0 }],
      'standardDeduction': 12000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.0539, 'threshold': 0 }],
      'standardDeduction': 24000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Georgia - 5.39% flat',
  },
  'HI': {
    'name': 'Hawaii',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.014, 'threshold': 0 },
        { 'rate': 0.032, 'threshold': 9600 },
        { 'rate': 0.055, 'threshold': 14400 },
        { 'rate': 0.064, 'threshold': 19200 },
        { 'rate': 0.068, 'threshold': 24000 },
        { 'rate': 0.072, 'threshold': 36000 },
        { 'rate': 0.076, 'threshold': 48000 },
        { 'rate': 0.079, 'threshold': 125000 },
        { 'rate': 0.0825, 'threshold': 175000 },
        { 'rate': 0.09, 'threshold': 225000 },
        { 'rate': 0.1, 'threshold': 275000 },
        { 'rate': 0.11, 'threshold': 325000 },
      ],
      'standardDeduction': 4400,
      'personalExemption': 1144,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.014, 'threshold': 0 },
        { 'rate': 0.032, 'threshold': 19200 },
        { 'rate': 0.055, 'threshold': 28800 },
        { 'rate': 0.064, 'threshold': 38400 },
        { 'rate': 0.068, 'threshold': 48000 },
        { 'rate': 0.072, 'threshold': 72000 },
        { 'rate': 0.076, 'threshold': 96000 },
        { 'rate': 0.079, 'threshold': 250000 },
        { 'rate': 0.0825, 'threshold': 350000 },
        { 'rate': 0.09, 'threshold': 450000 },
        { 'rate': 0.1, 'threshold': 550000 },
        { 'rate': 0.11, 'threshold': 650000 },
      ],
      'standardDeduction': 8800,
      'personalExemption': 2288,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Hawaii - 1.4% to 11%',
  },
  'ID': {
    'name': 'Idaho',
    'singleFiler': {
      'brackets': [{ 'rate': 0.05695, 'threshold': 4673 }],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.05695, 'threshold': 9346 }],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Idaho - 5.695% flat',
  },
  'IL': {
    'name': 'Illinois',
    'singleFiler': {
      'brackets': [{ 'rate': 0.0495, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': 2850,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.0495, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': 5700,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Illinois - 4.95% flat',
  },
  'IN': {
    'name': 'Indiana',
    'singleFiler': {
      'brackets': [{ 'rate': 0.03, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': 1000,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.03, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': 2000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Indiana - 3% flat',
  },
  'IA': {
    'name': 'Iowa',
    'singleFiler': {
      'brackets': [{ 'rate': 0.038, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.038, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Iowa - 3.8% flat',
  },
  'KS': {
    'name': 'Kansas',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.052, 'threshold': 0 },
        { 'rate': 0.0558, 'threshold': 23000 },
      ],
      'standardDeduction': 3605,
      'personalExemption': 9160,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.052, 'threshold': 0 },
        { 'rate': 0.0558, 'threshold': 46000 },
      ],
      'standardDeduction': 8240,
      'personalExemption': 18320,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Kansas - 5.2% to 5.58%',
  },
  'KY': {
    'name': 'Kentucky',
    'singleFiler': {
      'brackets': [{ 'rate': 0.04, 'threshold': 0 }],
      'standardDeduction': 3270,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.04, 'threshold': 0 }],
      'standardDeduction': 6540,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Kentucky - 4% flat',
  },
  'LA': {
    'name': 'Louisiana',
    'singleFiler': {
      'brackets': [{ 'rate': 0.03, 'threshold': 0 }],
      'standardDeduction': 12500,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.03, 'threshold': 0 }],
      'standardDeduction': 25000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Louisiana - 3% flat',
  },
  'ME': {
    'name': 'Maine',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.058, 'threshold': 0 },
        { 'rate': 0.0675, 'threshold': 26800 },
        { 'rate': 0.0715, 'threshold': 63450 },
      ],
      'standardDeduction': 15000,
      'personalExemption': 5150,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.058, 'threshold': 0 },
        { 'rate': 0.0675, 'threshold': 53600 },
        { 'rate': 0.0715, 'threshold': 126900 },
      ],
      'standardDeduction': 30000,
      'personalExemption': 10300,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Maine - 5.8% to 7.15%',
  },
  'MD': {
    'name': 'Maryland',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.03, 'threshold': 1000 },
        { 'rate': 0.04, 'threshold': 2000 },
        { 'rate': 0.0475, 'threshold': 3000 },
        { 'rate': 0.05, 'threshold': 100000 },
        { 'rate': 0.0525, 'threshold': 125000 },
        { 'rate': 0.055, 'threshold': 150000 },
        { 'rate': 0.0575, 'threshold': 250000 },
      ],
      'standardDeduction': 2700,
      'personalExemption': 3200,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.03, 'threshold': 1000 },
        { 'rate': 0.04, 'threshold': 2000 },
        { 'rate': 0.0475, 'threshold': 3000 },
        { 'rate': 0.05, 'threshold': 150000 },
        { 'rate': 0.0525, 'threshold': 175000 },
        { 'rate': 0.055, 'threshold': 225000 },
        { 'rate': 0.0575, 'threshold': 300000 },
      ],
      'standardDeduction': 5450,
      'personalExemption': 6400,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Maryland - 2% to 5.75%',
  },
  'MA': {
    'name': 'Massachusetts',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.05, 'threshold': 0 },
        { 'rate': 0.09, 'threshold': 1083150 },
      ],
      'standardDeduction': null,
      'personalExemption': 4400,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.05, 'threshold': 0 },
        { 'rate': 0.09, 'threshold': 1083150 },
      ],
      'standardDeduction': null,
      'personalExemption': 8800,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Massachusetts - 5% to 9%',
  },
  'MI': {
    'name': 'Michigan',
    'singleFiler': {
      'brackets': [{ 'rate': 0.0425, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': 5800,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.0425, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': 11600,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Michigan - 4.25% flat',
  },
  'MN': {
    'name': 'Minnesota',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0535, 'threshold': 0 },
        { 'rate': 0.068, 'threshold': 32570 },
        { 'rate': 0.0785, 'threshold': 106990 },
        { 'rate': 0.0985, 'threshold': 198630 },
      ],
      'standardDeduction': 14950,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0535, 'threshold': 0 },
        { 'rate': 0.068, 'threshold': 47620 },
        { 'rate': 0.0785, 'threshold': 189180 },
        { 'rate': 0.0985, 'threshold': 330410 },
      ],
      'standardDeduction': 29900,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Minnesota - 5.35% to 9.85%',
  },
  'MS': {
    'name': 'Mississippi',
    'singleFiler': {
      'brackets': [{ 'rate': 0.044, 'threshold': 10000 }],
      'standardDeduction': 2300,
      'personalExemption': 6000,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.044, 'threshold': 10000 }],
      'standardDeduction': 4600,
      'personalExemption': 12000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Mississippi - 4.4% (income over $10k)',
  },
  'MO': {
    'name': 'Missouri',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 1313 },
        { 'rate': 0.025, 'threshold': 2626 },
        { 'rate': 0.03, 'threshold': 3939 },
        { 'rate': 0.035, 'threshold': 5252 },
        { 'rate': 0.04, 'threshold': 6565 },
        { 'rate': 0.045, 'threshold': 7878 },
        { 'rate': 0.047, 'threshold': 9191 },
      ],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 1313 },
        { 'rate': 0.025, 'threshold': 2626 },
        { 'rate': 0.03, 'threshold': 3939 },
        { 'rate': 0.035, 'threshold': 5252 },
        { 'rate': 0.04, 'threshold': 6565 },
        { 'rate': 0.045, 'threshold': 7878 },
        { 'rate': 0.047, 'threshold': 9191 },
      ],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Missouri - 2% to 4.7%',
  },
  'MT': {
    'name': 'Montana',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.047, 'threshold': 0 },
        { 'rate': 0.059, 'threshold': 21100 },
      ],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.047, 'threshold': 0 },
        { 'rate': 0.059, 'threshold': 42200 },
      ],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Montana - 4.7% to 5.9%',
  },
  'NE': {
    'name': 'Nebraska',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0246, 'threshold': 0 },
        { 'rate': 0.0351, 'threshold': 4030 },
        { 'rate': 0.0501, 'threshold': 24120 },
        { 'rate': 0.052, 'threshold': 38870 },
      ],
      'standardDeduction': 8600,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0246, 'threshold': 0 },
        { 'rate': 0.0351, 'threshold': 8040 },
        { 'rate': 0.0501, 'threshold': 48250 },
        { 'rate': 0.052, 'threshold': 77730 },
      ],
      'standardDeduction': 17200,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Nebraska - 2.46% to 5.2%',
  },
  'NV': {
    'name': 'Nevada',
    'singleFiler': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'marriedJoint': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'hasIncomeTax': false,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'description': 'Nevada - No state income tax',
  },
  'NH': {
    'name': 'New Hampshire',
    'singleFiler': {
      'brackets': [],
      'dividendInterestBrackets': [
        { 'rate': 0.04, 'threshold': 2400 },
      ],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [],
      'dividendInterestBrackets': [
        { 'rate': 0.04, 'threshold': 4800 },
      ],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'hasDividendInterestTax': true,
    'description': 'New Hampshire - 4% on dividends & interest only',
  },
  'NJ': {
    'name': 'New Jersey',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.014, 'threshold': 0 },
        { 'rate': 0.0175, 'threshold': 20000 },
        { 'rate': 0.035, 'threshold': 35000 },
        { 'rate': 0.05525, 'threshold': 40000 },
        { 'rate': 0.0637, 'threshold': 75000 },
        { 'rate': 0.0897, 'threshold': 500000 },
        { 'rate': 0.1075, 'threshold': 1000000 },
      ],
      'standardDeduction': null,
      'personalExemption': 1000,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.014, 'threshold': 0 },
        { 'rate': 0.0175, 'threshold': 20000 },
        { 'rate': 0.0245, 'threshold': 50000 },
        { 'rate': 0.035, 'threshold': 70000 },
        { 'rate': 0.05525, 'threshold': 80000 },
        { 'rate': 0.0637, 'threshold': 150000 },
        { 'rate': 0.0897, 'threshold': 500000 },
      ],
      'standardDeduction': null,
      'personalExemption': 2000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'New Jersey - 1.4% to 10.75%',
  },
  'NM': {
    'name': 'New Mexico',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.015, 'threshold': 0 },
        { 'rate': 0.032, 'threshold': 5500 },
        { 'rate': 0.043, 'threshold': 16500 },
        { 'rate': 0.047, 'threshold': 33500 },
        { 'rate': 0.049, 'threshold': 66500 },
        { 'rate': 0.059, 'threshold': 210000 },
      ],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.015, 'threshold': 0 },
        { 'rate': 0.032, 'threshold': 8000 },
        { 'rate': 0.043, 'threshold': 25000 },
        { 'rate': 0.047, 'threshold': 50000 },
        { 'rate': 0.049, 'threshold': 100000 },
        { 'rate': 0.059, 'threshold': 315000 },
      ],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'New Mexico - 1.5% to 5.9%',
  },
  'NY': {
    'name': 'New York',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.04, 'threshold': 0 },
        { 'rate': 0.045, 'threshold': 8500 },
        { 'rate': 0.0525, 'threshold': 11700 },
        { 'rate': 0.055, 'threshold': 13900 },
        { 'rate': 0.06, 'threshold': 80650 },
        { 'rate': 0.0685, 'threshold': 215400 },
        { 'rate': 0.0965, 'threshold': 1077550 },
        { 'rate': 0.103, 'threshold': 5000000 },
        { 'rate': 0.109, 'threshold': 25000000 },
      ],
      'standardDeduction': 8000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.04, 'threshold': 0 },
        { 'rate': 0.045, 'threshold': 17150 },
        { 'rate': 0.0525, 'threshold': 23600 },
        { 'rate': 0.055, 'threshold': 27900 },
        { 'rate': 0.06, 'threshold': 161550 },
        { 'rate': 0.0685, 'threshold': 323200 },
        { 'rate': 0.0965, 'threshold': 2155350 },
        { 'rate': 0.103, 'threshold': 5000000 },
        { 'rate': 0.109, 'threshold': 25000000 },
      ],
      'standardDeduction': 16050,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'New York - 4% to 10.9%',
  },
  'NC': {
    'name': 'North Carolina',
    'singleFiler': {
      'brackets': [{ 'rate': 0.0425, 'threshold': 0 }],
      'standardDeduction': 12750,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.0425, 'threshold': 0 }],
      'standardDeduction': 25500,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'North Carolina - 4.25% flat',
  },
  'ND': {
    'name': 'North Dakota',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0195, 'threshold': 48475 },
        { 'rate': 0.025, 'threshold': 244825 },
      ],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0195, 'threshold': 80975 },
        { 'rate': 0.025, 'threshold': 298075 },
      ],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'North Dakota - 1.95% to 2.5%',
  },
  'OH': {
    'name': 'Ohio',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0275, 'threshold': 26050 },
        { 'rate': 0.035, 'threshold': 100000 },
      ],
      'standardDeduction': null,
      'personalExemption': 2400,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0275, 'threshold': 26050 },
        { 'rate': 0.035, 'threshold': 100000 },
      ],
      'standardDeduction': null,
      'personalExemption': 4800,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Ohio - 2.75% to 3.5%',
  },
  'OK': {
    'name': 'Oklahoma',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0025, 'threshold': 0 },
        { 'rate': 0.0075, 'threshold': 1000 },
        { 'rate': 0.0175, 'threshold': 2500 },
        { 'rate': 0.0275, 'threshold': 3750 },
        { 'rate': 0.0375, 'threshold': 4900 },
        { 'rate': 0.0475, 'threshold': 7200 },
      ],
      'standardDeduction': 6350,
      'personalExemption': 1000,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0025, 'threshold': 0 },
        { 'rate': 0.0075, 'threshold': 2000 },
        { 'rate': 0.0175, 'threshold': 5000 },
        { 'rate': 0.0275, 'threshold': 7500 },
        { 'rate': 0.0375, 'threshold': 9800 },
        { 'rate': 0.0475, 'threshold': 14400 },
      ],
      'standardDeduction': 12700,
      'personalExemption': 2000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Oklahoma - 0.25% to 4.75%',
  },
  'OR': {
    'name': 'Oregon',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0475, 'threshold': 0 },
        { 'rate': 0.0675, 'threshold': 4400 },
        { 'rate': 0.0875, 'threshold': 11050 },
        { 'rate': 0.099, 'threshold': 125000 },
      ],
      'standardDeduction': 2800,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0475, 'threshold': 0 },
        { 'rate': 0.0675, 'threshold': 8800 },
        { 'rate': 0.0875, 'threshold': 22100 },
        { 'rate': 0.099, 'threshold': 250000 },
      ],
      'standardDeduction': 5600,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Oregon - 4.75% to 9.9%',
  },
  'PA': {
    'name': 'Pennsylvania',
    'singleFiler': {
      'brackets': [{ 'rate': 0.0307, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.0307, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Pennsylvania - 3.07% flat',
  },
  'RI': {
    'name': 'Rhode Island',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0375, 'threshold': 0 },
        { 'rate': 0.0475, 'threshold': 79900 },
        { 'rate': 0.0599, 'threshold': 181650 },
      ],
      'standardDeduction': 10900,
      'personalExemption': 5100,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0375, 'threshold': 0 },
        { 'rate': 0.0475, 'threshold': 79900 },
        { 'rate': 0.0599, 'threshold': 181650 },
      ],
      'standardDeduction': 21800,
      'personalExemption': 10200,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Rhode Island - 3.75% to 5.99%',
  },
  'SC': {
    'name': 'South Carolina',
    'singleFiler': {
      'brackets': [
        { 'rate': 0, 'threshold': 0 },
        { 'rate': 0.03, 'threshold': 3560 },
        { 'rate': 0.062, 'threshold': 17830 },
      ],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0, 'threshold': 0 },
        { 'rate': 0.03, 'threshold': 3560 },
        { 'rate': 0.062, 'threshold': 17830 },
      ],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'South Carolina - 0% to 6.2%',
  },
  'SD': {
    'name': 'South Dakota',
    'singleFiler': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'marriedJoint': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'hasIncomeTax': false,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'description': 'South Dakota - No state income tax',
  },
  'TN': {
    'name': 'Tennessee',
    'singleFiler': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'marriedJoint': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'hasIncomeTax': false,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'description': 'Tennessee - No state income tax',
  },
  'TX': {
    'name': 'Texas',
    'singleFiler': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'marriedJoint': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'hasIncomeTax': false,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'description': 'Texas - No state income tax',
  },
  'UT': {
    'name': 'Utah',
    'singleFiler': {
      'brackets': [{ 'rate': 0.0455, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [{ 'rate': 0.0455, 'threshold': 0 }],
      'standardDeduction': null,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Utah - 4.55% flat',
  },
  'VT': {
    'name': 'Vermont',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0335, 'threshold': 0 },
        { 'rate': 0.066, 'threshold': 47900 },
        { 'rate': 0.076, 'threshold': 116000 },
        { 'rate': 0.0875, 'threshold': 242000 },
      ],
      'standardDeduction': 7400,
      'personalExemption': 5100,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0335, 'threshold': 0 },
        { 'rate': 0.066, 'threshold': 79950 },
        { 'rate': 0.076, 'threshold': 193300 },
        { 'rate': 0.0875, 'threshold': 294600 },
      ],
      'standardDeduction': 14850,
      'personalExemption': 10200,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Vermont - 3.35% to 8.75%',
  },
  'VA': {
    'name': 'Virginia',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.03, 'threshold': 3000 },
        { 'rate': 0.05, 'threshold': 5000 },
        { 'rate': 0.0575, 'threshold': 17000 },
      ],
      'standardDeduction': 8500,
      'personalExemption': 930,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.02, 'threshold': 0 },
        { 'rate': 0.03, 'threshold': 3000 },
        { 'rate': 0.05, 'threshold': 5000 },
        { 'rate': 0.0575, 'threshold': 17000 },
      ],
      'standardDeduction': 17000,
      'personalExemption': 1860,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Virginia - 2% to 5.75%',
  },
  'WA': {
    'name': 'Washington',
    'singleFiler': {
      'brackets': [],
      'capitalGainsBrackets': [
        { 'rate': 0.07, 'threshold': 0 },
      ],
      'standardDeduction': null,
      'personalExemption': null,
      'capitalGainsExemption': 270000,
    },
    'marriedJoint': {
      'brackets': [],
      'capitalGainsBrackets': [
        { 'rate': 0.07, 'threshold': 0 },
      ],
      'standardDeduction': null,
      'personalExemption': null,
      'capitalGainsExemption': 270000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': false,
    'description': 'Washington - 7% capital gains tax only ($270k exemption)',
  },
  'WV': {
    'name': 'West Virginia',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.0222, 'threshold': 0 },
        { 'rate': 0.0296, 'threshold': 10000 },
        { 'rate': 0.0333, 'threshold': 25000 },
        { 'rate': 0.0444, 'threshold': 40000 },
        { 'rate': 0.0482, 'threshold': 60000 },
      ],
      'standardDeduction': null,
      'personalExemption': 2000,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.0222, 'threshold': 0 },
        { 'rate': 0.0296, 'threshold': 10000 },
        { 'rate': 0.0333, 'threshold': 25000 },
        { 'rate': 0.0444, 'threshold': 40000 },
        { 'rate': 0.0482, 'threshold': 60000 },
      ],
      'standardDeduction': null,
      'personalExemption': 4000,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'West Virginia - 2.22% to 4.82%',
  },
  'WI': {
    'name': 'Wisconsin',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.035, 'threshold': 0 },
        { 'rate': 0.044, 'threshold': 14680 },
        { 'rate': 0.053, 'threshold': 29370 },
        { 'rate': 0.0765, 'threshold': 323290 },
      ],
      'standardDeduction': 13560,
      'personalExemption': 700,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.035, 'threshold': 0 },
        { 'rate': 0.044, 'threshold': 19580 },
        { 'rate': 0.053, 'threshold': 39150 },
        { 'rate': 0.0765, 'threshold': 431060 },
      ],
      'standardDeduction': 25110,
      'personalExemption': 1400,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Wisconsin - 3.5% to 7.65%',
  },
  'WY': {
    'name': 'Wyoming',
    'singleFiler': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'marriedJoint': { 'brackets': [], 'standardDeduction': null, 'personalExemption': null },
    'hasIncomeTax': false,
    'hasGeneralIncomeTax': false,
    'hasCapitalGainsTax': false,
    'description': 'Wyoming - No state income tax',
  },
  'DC': {
    'name': 'Washington DC',
    'singleFiler': {
      'brackets': [
        { 'rate': 0.04, 'threshold': 0 },
        { 'rate': 0.06, 'threshold': 10000 },
        { 'rate': 0.065, 'threshold': 40000 },
        { 'rate': 0.085, 'threshold': 60000 },
        { 'rate': 0.0925, 'threshold': 250000 },
        { 'rate': 0.0975, 'threshold': 500000 },
        { 'rate': 0.1075, 'threshold': 1000000 },
      ],
      'standardDeduction': 15000,
      'personalExemption': null,
    },
    'marriedJoint': {
      'brackets': [
        { 'rate': 0.04, 'threshold': 0 },
        { 'rate': 0.06, 'threshold': 10000 },
        { 'rate': 0.065, 'threshold': 40000 },
        { 'rate': 0.085, 'threshold': 60000 },
        { 'rate': 0.0925, 'threshold': 250000 },
        { 'rate': 0.0975, 'threshold': 500000 },
        { 'rate': 0.1075, 'threshold': 1000000 },
      ],
      'standardDeduction': 30000,
      'personalExemption': null,
    },
    'hasIncomeTax': true,
    'hasGeneralIncomeTax': true,
    'hasCapitalGainsTax': true,
    'capitalGainsTaxSameAsOrdinary': true,
    'description': 'Washington DC - 4% to 10.75%',
  },
};

